<template>
    <div class="svg-box" :style="{ width: (btn.width + 60)+'px', height: ( btn.height + 60 )+'px', top: (btn.top - 30)+'px', left: ( btn.left - 30 ) +'px' }">
        <svg xmlns="http://www.w3.org/2000/svg" :width="btn.width+60+'px'" :height="btn.height+60+'px'">
            <rect class="svg-edit-box" :height="btn.height" :width="btn.width" fill="none" style="stroke:black;stroke-width:2;stroke-dasharray:10 5" x="30" y="30"></rect>
            <rect height="4" :width="btn.width+30" y="9" x="6" fill-opacity="null" stroke-opacity="null" fill="#c0c0c0"/>
            <rect height="4" :width="btn.width+30" :y="btn.height+45" x="6" fill="#c0c0c0"/>
            <rect :height="btn.height+30" width="4" y="7" x="10" fill="#c0c0c0"/>
            <rect :height="btn.height+30" width="4" y="7" :x="btn.width+46" fill="#c0c0c0"/>
            <circle id="nw" fill="#c0c0c0" stroke="#555555" stroke-width="2.5" r="10" cx="12" cy="12" />
            <circle id="ne" fill="#c0c0c0" stroke="#555555" stroke-width="2.5" r="10" :cx="btn.width+48" cy="12" />
            <circle id="se" fill="#c0c0c0" stroke="#555555" stroke-width="2.5" r="10" :cx="btn.width+48" :cy="btn.height+48" />
            <circle id="sw" fill="#c0c0c0" stroke="#555555" stroke-width="2.5" r="10" cx="12" :cy="btn.height+48" />
            <rect id="e" :height="30" width="10" stroke="#555555" stroke-width="2.5" :y="( btn.height / 2 ) + 15" :x="btn.width+43" fill="#c0c0c0"/>
            <rect id="w" :height="30" width="10" stroke="#555555" stroke-width="2.5" :y="( btn.height / 2 ) + 15" :x="7" fill="#c0c0c0"/>
            <rect id="n" :height="10" width="35" stroke="#555555" stroke-width="2.5" :x="( btn.width / 2 ) + 12" :y="7" fill="#c0c0c0"/>
            <rect id="s" :height="10" width="35" stroke="#555555" stroke-width="2.5" :x="( btn.width / 2 ) + 12" :y="btn.height + 42" fill="#c0c0c0"/>
        </svg>
        <p v-if="btn.type == 'text'" @contextmenu.prevent="$refs.menu.open" style="width:calc(100% - 60px);position: absolute;top: 0px;left:0px">
            <span :class="btn.css" style="width: 100%;position: absolute;top:30px;left:30px;outline:0px solid transparent" @keyup="updateText($event)" :style="{ fontSize: btn.fontSize+'px', lineHeight: btn.lineHeight, textAlign: btn.textAlign, fontWeight: btn.fontWeight, backgroundColor: btn.backgroundColor, color: btn.fontColor }" v-html="value"></span>
        </p>
        <div class="svg-pos nw">
            <p>{{ btn.left+', '+btn.top }}</p>
        </div>
        <div class="svg-pos se">
            <p>{{ btn.width+', '+btn.height }}</p>
        </div>
        <vue-context ref="menu" @open="onOpen">
            <li>
                <a href="#" @click.prevent="onClick('bold')">Bold</a>
            </li>
            <li>
                <a href="#" @click.prevent="onClick('italic')">Italic</a>
            </li>
            <li>
                <a href="#" @click.prevent="onClick('copy')">Copy</a>
            </li>
            <li>
                <a href="#" @click.prevent="onClick('paste')">Paste</a>
            </li>
        </vue-context>
    </div>
</template>

<script>

import VueContext from 'vue-context'
import 'vue-context/src/sass/vue-context.scss';

export default {
    props: ['btn'],
    components: { VueContext },
    beforeDestroy () {

        this.text && ( this.text.style.display = 'inline' );
    },
    data () {
        return {
            text: false,
            value: ''
        }
    },
    mounted () {
        if ( this.btn.type == 'text' ) {
            return;
            this.value = this.btn.value;
            this.text = this.$el.parentElement.parentElement.querySelector('p span');
            this.text.style.display = 'none';
            var svgBox = this.$el.querySelector('.svg-edit-box');
            var editable = this.$el.querySelector('span');
                editable.contentEditable = false;
                editable.ondblclick = e => {
                    e.stopPropagation();
                    editable.contentEditable = true;
                    editable.focus();
                    svgBox.style.strokeDasharray = '2, 2';
                    svgBox.style.stroke = 'red'
                }
                editable.onmousemove = e => {
                    if ( !editable.contentEditable ) {
                        e.stopPropagation();
                    }
                }
                editable.onmousedown = e => {
                    if ( !editable.contentEditable ) {
                        e.stopPropagation();
                    }                   
                }
                editable.onblur = e => {
                    editable.contentEditable = false;
                    svgBox.style.strokeDasharray = '10, 6';
                    svgBox.style.stoke = '#000000';
                }
                
        };
    },
    methods: {
        updateText ( e ) {
            this.$emit('setBtnValue',{ btn: this.btn, value: e.target.innerHTML });
        },
        onClick ( type ) {
            console.log('click ??');
            var selObj = window.getSelection();
                console.log('selObj',selObj);
            var { anchorNode, anchorOffset, focusNode, focusOffset } = selObj;
                console.log({ 
                    anchorNode, 
                    anchorOffset, 
                    focusNode, 
                    focusOffset 
                });
                console.log('toString()',selObj.toString());
                console.log(type);
        },
        onOpen ( e ) {
            var rect = this.$el.getBoundingClientRect();
            var contextMenu = this.$refs.menu.$el;
                setTimeout(() => {
                    contextMenu.onmouseleave = () => { this.$refs.menu.close() };
                    contextMenu.style.left = (e.clientX - rect.x - 5)+'px';
                    contextMenu.style.top = (e.clientY - rect.y - 5)+'px';
                },30);   
        }
    }
}

</script>

<style lang="scss">
.svg-box {
    position: absolute;
    z-index: 100;
    ul {
        background-color: white;
        width: 100px;
        max-height: auto;
        position: absolute;
    }
    .svg-pos {
        position: absolute;
        &.nw {
            top: -5px;
            left: 35px;
            font-size: 12px;
        }
        &.se {
            font-size: 12px;
            top: calc(100% - 12px);
            right: 30px;
        }
    }
}
</style>